module.exports = __webpack_public_path__ + "img/Weapon_39.5ef2b827.png";